<div class="login-page">
  <div class="login-page__header">
    <div class="login-page__logo">
      <itc-themed-image
        lightSrc="assets/icons/kaseya-one/kaseya-one-logo-light.svg"
        darkSrc="assets/icons/kaseya-one/kaseya-one-logo-dark.svg"
        [width]="210"
        [height]="40"
        [alt]="'login.alts.logo' | translate"
      />
    </div>
  </div>

  @if (isLoginDegradationBannerEnabled()) {
    <kds-banner class="login-page__banner" typeIconPosition="baseline" [type]="BannerType.Error">
      <span>
        {{ 'login.degradation-banner.message-prefix' | translate }}
        <a kds-link target="_blank" rel="noopener noreferrer" [href]="statusPageUrl">
          {{ 'login.degradation-banner.status-page-link' | translate }}
        </a>
        {{ 'login.degradation-banner.message-suffix' | translate }}
      </span>
    </kds-banner>
  }

  @if (!isUserLoggedIn() && configurationForm) {
    @switch (currentStep()) {
      @case (LoginStep.Configuration) {
        <itc-login-configuration [loginConfigurationForm]="configurationForm" [organizationName]="companyName()" [uuid]="uuid()" />
      }
      @case (LoginStep.Flow) {
        <itc-login-flow [configurationForm]="configurationForm" [uuid]="uuid()" />
      }
    }
  }
</div>
